import { ModuleWrapper } from './module.component';

export * from './module.component';
export default ModuleWrapper;

ModuleWrapper.define('der-ui-module-wrapper');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-module-wrapper': ModuleWrapper;
    }
}
